/**
 * Pagination constants used across the application
 */

/** Default page size for frontend table pagination (client-side) */
export const TABLE_PAGE_SIZE = 10;
